module.exports = __webpack_public_path__ + "static/media/completed_I.ac968fe8.svg";